<template>
  <v-container fluid
  ><form action @submit.prevent="submitForm">
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="field">
      <InputField
        v-model="userData.email"
        disabled
        :labelTitle="$t('app.editProfile.email')"
        type="email"
        required
        :placeholder="$t('app.editProfile.email')"
        margin="25px auto"
      ></InputField>
      <InputField
        v-model="userData.nickName"
        :labelTitle="$t('app.editProfile.displayName')"
        required
        :placeholder="$t('app.editProfile.displayName')"
        margin="25px auto"
      ></InputField>
      <InputField
        v-model="userData.firstName"
        :labelTitle="$t('app.editProfile.firstName')"
        :placeholder="$t('app.editProfile.firstName')"
      ></InputField>
      <InputField
        v-model="userData.lastName"
        :labelTitle="$t('app.editProfile.lastName')"
        :placeholder="$t('app.editProfile.lastName')"
        margin="25px auto"
      ></InputField>
      <InputField
        v-model="userData.phone"
        :errorMessage="phoneError"
        @input="onPhoneInput"
        :labelTitle="$t('app.temp-home.phone')"
        type="tel"
        :placeholder="$t('app.temp-home.phone')"
      ></InputField>
      <TextAreaField
        class="input"
        v-model="userData.bio"
        :labelTitle="$t('app.editProfile.bio')"
        :placeholder="$t('app.editProfile.bio')"
        rows="2"
        style="margin-bottom: 32px"
      />
      <Button
        type="submit"
        :title="$t('app.editProfile.save')"
        margin="0 auto 25px auto"
      ></Button>
    </div></form
  ></v-container>
</template>

<script>
import { neoparentUsers } from "@/api";
import {consoleLog, redirect} from "@/helpers";

export default {
  name: "neoparent-edit-profile",
  data() {
    return {
      success: "",
      error: "",
      phoneError: "",
      userData: {},
      loading: false
    };
  },
  mounted() {
    const user = this.$store.getters.user
    this.userData = {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      nickName: user.nickName,
      bio: user.bio,
      phone: user.phone
    }
  },
  methods: {
    onPhoneInput(value) {
      if (this.phoneError && (!value || /^[0-9+\-\s()]+$/.test(value))) {
        this.phoneError = "";
      }
    },
    submitForm() {
      this.error = "";
      this.phoneError = "";
      this.loading = true;

      if (this.userData.phone && !/^[0-9+\-\s()]+$/.test(this.userData.phone)) {
        this.phoneError = this.$t("error.phone.invalid");
        this.loading = false;
        return;
      }

      neoparentUsers
        .updateUserData(this.userData)
        .then((res) => {
          consoleLog(res.data)
          if (!res.data.success) {
            this.phoneError = this.$t("error.phone.invalid");
          } else {
            redirect("/settings");
            const user = this.$store.getters.user;
            user.firstName = this.userData.firstName;
            user.lastName = this.userData.lastName;
            user.nickName = this.userData.nickName;
            user.bio = this.userData.bio;
            this.success = this.$t("success.profileUpdated");
          }
          this.loading = false;
        })
        .catch(err => {
          this.consoleLog(err);
          this.error = err.response.data.message;
          window.scrollTo(0, 0);
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
